import { takeLatest, put, call } from 'redux-saga/effects';

import { history } from '@commons';

import { createTransferenciaEstoqueProducao, updateTransferenciaEstoqueProducao } from '../service';
import {
  CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO,
  CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO_PENDING,
  CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO_SUCCESS,
  CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO_FAILURE,
  CONFIG_SESSION
} from '@handler';

import { storage } from '@commons/storage';

import { AlertSuccess, AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaCreateTransferenciaEstoqueProducao(action) {
  yield put({ type: CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO_PENDING })

  try {
    if (action.data.id === undefined || action.data.id === null) {
      yield call(createTransferenciaEstoqueProducao, {
        ...action.data,
        propriedade: {
          id: JSON.parse(storage.get(CONFIG_SESSION)).fazendaSelecionada.id
        },
      });
      trackingEventCX('action', MODULE_ACTIONS_ENUM.TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_CRIAR);
    } else {
      yield call(updateTransferenciaEstoqueProducao,
        {
          ...action.data,
          id: action.data.id
        }
      );
      trackingEventCX('action', MODULE_ACTIONS_ENUM.TRANSFERENCIA_ESTOQUE_PRODUCAO_AGRICOLA_EDITAR);
    }

    yield put({ type: CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO_SUCCESS, registro: action.data });
    history.push('/agricultura/producao/transferencia');
    AlertSuccess('Registro salvo com sucesso!');
  } catch (error) {
    yield put({ type: CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO_FAILURE, registro: action.data });
    AlertError('Falha ao salvar o registro! Tente novamente...');
  }
}

export default function* watchCreateTransferenciaEstoqueProducao() {
  yield takeLatest(CREATE_TRANSFERENCIA_ESTOQUE_PRODUCAO, sagaCreateTransferenciaEstoqueProducao);
}
